define('lq/events/actions/apiCallv2',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function APICallv2Command(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(APICallv2Command, EventAction);

    APICallv2Command.typeName = 'APICallv2';

    APICallv2Command.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    APICallv2Command.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'APICallv2',
            command: this.eventData.command
        };
    };

    return APICallv2Command;
});
